<template>
  <div>
    <header class="header">
      <div class="header__inner">
        <a class="header__logo" href="/">
          <svg width="72" height="55" viewBox="0 0 72.64 55.64">
            <title>Campsite</title>
            <path
              fill="#395135"
              d="M70.09 32.4c-4-8.49-9.3-18.18-11.76-25.07a9.25 9.25 0 0 0-9.7-6.11c-5.43.59-12.61 1-18.5 1.24-4.93.2-6.31 1.92-6.31 1.92C21.15 5.49 1.74 42.15 1.74 42.15a3.43 3.43 0 0 0 1.67 5.45c12.06 3.41 41.46 9.23 47 6.19A81.77 81.77 0 0 0 67.64 45c4.06-2.87 4.58-8 2.45-12.6z"
            />
            <path
              fill="#233020"
              d="M71.33 31.81c-1.38-3-2.94-6.1-4.45-9.13A163.13 163.13 0 0 1 59.6 6.83 10.22 10.22 0 0 0 48.86.06c-4.43.48-10.8.94-18.43 1.23a8 8 0 0 0-1.8.28C25 2 23.52 3.24 23.14 3.65 19.71 6.39 5.37 33.16.89 41.63a4.7 4.7 0 0 0-.64 4.23 4.22 4.22 0 0 0 2.89 2.7A249.53 249.53 0 0 0 29.2 54.1a105.75 105.75 0 0 0 15.45 1.54c2.93 0 5-.31 6.21-.94q4.67-1.82 8.69-3.83a69.77 69.77 0 0 0 9-5.26c4.15-2.9 5.27-8.45 2.78-13.8zM50.41 52.69c-3.12 1.21-5-.15-7.45-3.27-7.63-9.52-13.29-21.35-16.84-35.17-1-3.83-.72-7.26.7-9.17A4.22 4.22 0 0 1 29 3.54c.36 0 .75-.07 1.17-.08 7.78-.33 14-.75 18.56-1.24a8.21 8.21 0 0 1 8.64 5.45 164.43 164.43 0 0 0 7.37 16.07c1.51 3 3.06 6.15 4.43 9.08 2.1 4.51 1.27 9-2.11 11.32a67.27 67.27 0 0 1-8.43 4.95q-3.8 1.91-8.22 3.6zM3.68 46.64a2.22 2.22 0 0 1-1.54-1.44 2.7 2.7 0 0 1 .41-2.46l.07-.12C9.9 28.89 22.2 6.61 24.21 5.3l.23-.11c-1.13 2.43-1.24 5.82-.27 9.58 3.62 14.09 9.41 26.18 17.21 35.93a17.23 17.23 0 0 0 2.86 3 110.18 110.18 0 0 1-14.74-1.51 247.38 247.38 0 0 1-25.82-5.55z"
            />
            <path
              fill="#233020"
              d="M27.58 52.82c-.92-2.8-6.2-19.19-6.85-28.53a.35.35 0 0 0-.66-.11l-15.23 15 6.4 9.41-.18.49a.35.35 0 0 0 .26.47l16.08 3.26c.24.19.24.19.18.01zM7.42 39.42l11.41-11.85-7.15 19.76z"
            />
          </svg>
          <span>Campsite</span>
        </a>
      </div>
    </header>
    <Banner class="banner--error">
      <div class="banner__stars banner__stars--1"></div>
      <div class="banner__stars banner__stars--2"></div>
      <div class="banner__stars banner__stars--3"></div>
      <div class="shooting-star">
        <div class="shooting-star__star"></div>
      </div>
      <div class="banner__ground banner__ground--middle">
        <div class="banner__tree-holder">
          <svg class="banner__tree banner__tree--1" viewBox="0 0 70 101">
            <path
              d="M69 86.7L54.3 62.2h10.2L48.9 36.3h7.7L35.2.8 13.4 36.3h8L5.5 62.2H16L1 86.7h30.3v13.6h8.4V86.7"
            />
          </svg>
          <svg class="banner__tree banner__tree--2" viewBox="0 0 70 101">
            <path
              d="M69 86.7L54.3 62.2h10.2L48.9 36.3h7.7L35.2.8 13.4 36.3h8L5.5 62.2H16L1 86.7h30.3v13.6h8.4V86.7"
            />
          </svg>
          <svg class="banner__tree banner__tree--3" viewBox="0 0 70 101">
            <path
              d="M69 86.7L54.3 62.2h10.2L48.9 36.3h7.7L35.2.8 13.4 36.3h8L5.5 62.2H16L1 86.7h30.3v13.6h8.4V86.7"
            />
          </svg>
          <svg class="banner__tree banner__tree--4" viewBox="0 0 70 101">
            <path
              d="M69 86.7L54.3 62.2h10.2L48.9 36.3h7.7L35.2.8 13.4 36.3h8L5.5 62.2H16L1 86.7h30.3v13.6h8.4V86.7"
            />
          </svg>
          <svg class="banner__tree banner__tree--5" viewBox="0 0 70 101">
            <path
              d="M69 86.7L54.3 62.2h10.2L48.9 36.3h7.7L35.2.8 13.4 36.3h8L5.5 62.2H16L1 86.7h30.3v13.6h8.4V86.7"
            />
          </svg>
          <svg class="banner__tree banner__tree--6" viewBox="0 0 70 101">
            <path
              d="M69 86.7L54.3 62.2h10.2L48.9 36.3h7.7L35.2.8 13.4 36.3h8L5.5 62.2H16L1 86.7h30.3v13.6h8.4V86.7"
            />
          </svg>
          <svg class="banner__tree banner__tree--7" viewBox="0 0 70 101">
            <path
              d="M69 86.7L54.3 62.2h10.2L48.9 36.3h7.7L35.2.8 13.4 36.3h8L5.5 62.2H16L1 86.7h30.3v13.6h8.4V86.7"
            />
          </svg>
          <svg class="banner__tree banner__tree--8" viewBox="0 0 70 101">
            <path
              d="M69 86.7L54.3 62.2h10.2L48.9 36.3h7.7L35.2.8 13.4 36.3h8L5.5 62.2H16L1 86.7h30.3v13.6h8.4V86.7"
            />
          </svg>
        </div>
      </div>
      <div class="banner__ground"></div>
      <div class="grid grid--container">
        <div class="banner__content-container">
          <div class="banner__content">
            <template v-if="error.statusCode === 404">
              <h1 class="banner__title">You look lost</h1>
              <p class="banner__text">
                This page doesn't seem to exist. <br />No problem though, just
                head back <a href="/">home</a> and everything should be alright.
              </p>
            </template>
            <template v-else>
              <h1 class="banner__title">Server Error</h1>
              <p class="banner__text">
                This page is having some trouble loading. Please
                <a href="mailto:support@campsite.bio">contact us</a> if this
                issue persists.
              </p>
            </template>
          </div>
        </div>
      </div>
    </Banner>
  </div>
</template>

<script>
import defaultOG from '@/assets/default-og';
import Banner from '@/components/banner';

export default {
  props: ['error'],

  layout: 'errorlayout',

  head() {
    return {
      link: [
        {
          rel: 'stylesheet',
          href:
            'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;0,800;1,400&family=Sanchez&display=swap',
        },
      ],
      title: `${
        this.error.statusCode === 404 ? 'Page Not Found' : 'Server Error'
      } - Campsite`,
      meta: [...defaultOG],
    };
  },

  components: {
    Banner,
  },
};
</script>

<style lang="scss">
body {
  font-family: $font-family;
}

h1 {
  font-family: $font-header;
}
</style>

<style lang="scss" scoped>
.header {
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  height: 50px;
  padding: 0;
  text-align: center;
}

.header__inner {
  margin: 0 auto;
  max-width: 1200px;
  padding: 0 15px;
}

.header__logo {
  color: #333;
  display: inline-block;
  text-decoration: none;
}

.header__logo {
  margin-top: 10px;
}

.header__logo svg,
.header__logo span {
  display: inline-block;
  vertical-align: middle;
}

.header__logo svg {
  height: 30px;
  margin-right: 5px;
  width: 40px;
}

.header__logo span {
  font-family: 'Sanchez', serif;
  font-size: 20px;
  font-weight: 600;
}

.banner--error {
  min-height: calc(100vh - 50px);
}
</style>
